import { render, staticRenderFns } from "./ManagerMarket.vue?vue&type=template&id=b08c15d8&scoped=true"
import script from "./ManagerMarket.vue?vue&type=script&lang=js"
export * from "./ManagerMarket.vue?vue&type=script&lang=js"
import style0 from "./ManagerMarket.vue?vue&type=style&index=0&id=b08c15d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c15d8",
  null
  
)

export default component.exports